import Container from './AdditionalImagesPopup.container';
import AdditionalImagesPopup from './AdditionalImagesPopup';

export default Container(AdditionalImagesPopup);
